import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import {
  Container,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "components/_Common/Breadcrumb";

// actions
import { editProfile, passwordChange, viewProfile } from "store/actions";

import toastr from "toastr";
import { withTranslation } from "react-i18next";

const UserProfile = props => {
  //meta title
  document.title = "Profile | Admin & Dashboard";

  const dispatch = useDispatch();
  const { error, success, loading } = useSelector(state => ({
    loading: state.Profile.loading,
    error: state.Profile.error,
    success: state.Profile.success,
  }));

  const [profileData, setProfileData] = useState()

  useEffect(() => {
    if (!success?.data) {
      dispatch(viewProfile('survey/participant/auth/me', (res) => {
      }));

    }
    setProfileData(success?.data)
  }, [success]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      firstname: profileData?.firstname || '',
      lastname: profileData?.lastname || '',
      email: profileData?.email || '',
      phone_number: profileData?.phone_number | ''
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(editProfile(values, (res) => {
        if (res.status === 'success') {
          toastr.success(res.message)
          dispatch(viewProfile());
        } else {
          toastr.error(res.message)
        }
      }));
    }
  });

  const validationPasswordChange = useFormik({
    enableReinitialize: true,

    initialValues: {
      current_password: '' || '',
      new_password: '' || '',
      confirm_password: '' || '',
    },
    validationSchema: Yup.object({
      current_password: Yup.string().required(props.t("Please Enter Your Current Password")),
      new_password: Yup.string().required(props.t("Please Enter Your New Password")),
      confirm_password: Yup.string().required(props.t("Please Enter Confirm Password")),
    }),
    onSubmit: (values) => {
      dispatch(passwordChange(values, (res) => {
        if (values.new_password != values.confirm_password) {
          toastr.error("Your password not match.")
          return
        }
        if (res.status === 'success') {
          toastr.success(res.message)
          dispatch(viewProfile());

        } else {
          toastr.error(res.message)
        }
      }));
    }

  });


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Schor" breadcrumbItem="Profile" />
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col lg="4">
                <div className="mb-3 d-block">
                  <Label className="form-label m-0 pb-1">{props.t("First Name")}:</Label>
                  <Input
                    name="firstname"
                    className="form-control"
                    placeholder={props.t("Enter First Name")}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.firstname || ""}
                    invalid={
                      validation.touched.firstname && validation.errors.firstname ? true : false
                    }
                  />
                  {validation.touched.firstname && validation.errors.firstname ? (
                    <FormFeedback type="invalid">{validation.errors.firstname}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg="4">
                <div className="mb-3 d-block">
                  <Label className="form-label m-0 pb-1">{props.t("Last Name")}:</Label>
                  <Input
                    name="lastname"
                    className="form-control"
                    placeholder={props.t("Enter Last Name")}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lastname || ""}
                    invalid={
                      validation.touched.lastname && validation.errors.lastname ? true : false
                    }
                  />
                  {validation.touched.lastname && validation.errors.lastname ? (
                    <FormFeedback type="invalid">{validation.errors.lastname}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg="4"></Col>
              <Col lg="4">
                <div className="mb-3 d-block">
                  <Label className="form-label m-0 pb-1">{props.t("Email")}:</Label>
                  <Input
                    name="email"
                    className="form-control"
                    placeholder={props.t("Enter Email")}
                    disabled
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                </div>

              </Col>
              <Col lg="4">
                <div className="mb-3 d-block">
                  <Label className="form-label m-0 pb-1">{props.t("Phone Number")}:</Label>
                  <Input
                    name="phone_number"
                    className="form-control"
                    placeholder={props.t("Enter Phone Number")}
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phone_number || ""}
                    invalid={
                      validation.touched.phone_number && validation.errors.phone_number ? true : false
                    }
                  />
                  {validation.touched.phone_number && validation.errors.phone_number ? (
                    <FormFeedback type="invalid">{validation.errors.phone_number}</FormFeedback>
                  ) : null}
                </div>

              </Col>
            </Row>
            {/* {
              loading ?
                <div className="btn-login-admin mt-3">

                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    disabled
                  >
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                    Submit
                  </button>
                </div>
                :
                <div className="btn-login-admin mt-3">
                  <button
                    className="btn btn-primary btn-block"
                    type="submit"
                  // disabled
                  >
                    Submit
                  </button>
                </div>
            } */}

            <div className="btn-login-admin mt-2">
              <button
                className="btn btn-primary btn-block"
                type="submit"
                disabled={loading}
              >
                {props.t("Submit")}
              </button>
            </div>
          </Form>
          <h4 className="card-title mb-4 mt-4">{props.t("Password Change")}</h4>
          <Row>

            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault();
                validationPasswordChange.handleSubmit();
                return false;
              }}
            >
              <Row>
                <Col lg="4">
                  <div className="mb-3 d-block">
                    <Label className="form-label m-0 pb-1">{props.t("Current Password:")}</Label>
                    <Input
                      name="current_password"
                      className="form-control"
                      placeholder={props.t("Enter Current Password")}
                      type="password"
                      onChange={validationPasswordChange.handleChange}
                      onBlur={validationPasswordChange.handleBlur}
                      value={validationPasswordChange.values.current_password || ""}
                      invalid={
                        validationPasswordChange.touched.current_password && validationPasswordChange.errors.current_password ? true : false
                      }
                    />
                    {validationPasswordChange.touched.current_password && validationPasswordChange.errors.current_password ? (
                      <FormFeedback type="invalid">{validationPasswordChange.errors.current_password}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col lg="8"></Col>

                <Col lg="4">
                  <div className="mb-3 d-block">
                    <Label className="form-label m-0 pb-1">{props.t("New Password")}:</Label>
                    <Input
                      name="new_password"
                      className="form-control"
                      placeholder={props.t("Enter Your New Password.")}
                      type="password"
                      onChange={validationPasswordChange.handleChange}
                      onBlur={validationPasswordChange.handleBlur}
                      value={validationPasswordChange.values.new_password || ""}
                      invalid={
                        validationPasswordChange.touched.new_password && validationPasswordChange.errors.new_password ? true : false
                      }
                    />
                    {validationPasswordChange.touched.new_password && validationPasswordChange.errors.new_password ? (
                      <FormFeedback type="invalid">{validationPasswordChange.errors.new_password}</FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col lg="8"></Col>

                <Col lg="4">
                  <div className="mb-3 d-block">
                    <Label className="form-label m-0 pb-1">{props.t("Confirm Password")}</Label>
                    <Input
                      name="confirm_password"
                      className="form-control"
                      placeholder={props.t("Enter Confirm Password")}
                      type="password"
                      onChange={validationPasswordChange.handleChange}
                      onBlur={validationPasswordChange.handleBlur}
                      value={validationPasswordChange.values.confirm_password || ""}
                      invalid={
                        validationPasswordChange.touched.confirm_password && validationPasswordChange.errors.confirm_password ? true : false
                      }
                    />
                    {validationPasswordChange.touched.confirm_password && validationPasswordChange.errors.confirm_password ? (
                      <FormFeedback type="invalid">{validationPasswordChange.errors.confirm_password}</FormFeedback>
                    ) : null}
                  </div>

                </Col>
              </Row>
              <div className="btn-login-admin mt-2 mb-4">
                <button
                  className="btn btn-primary btn-block"
                  type="submit"
                  disabled={loading}
                >
                  {props.t("Submit")}
                </button>
              </div>
            </Form>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

UserProfile.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,

};

export default withTranslation()(UserProfile);
